<template lang="pug">
.bg-img: .container
  page-header(
    :disable-back="true"
    :disable-home="true"
    :disable-close="true"
  )
  .row
    .col-6
      .wrapper: .content: .page
        h2 Siemensstadt Square
        h3 Eingangsplatz
        h3 Ausstellung zum Freiraumplanerischen Realisierungswettbewerb
        router-link.btn(to="/menu") zu den Entwürfen
    .col-4.img-home
      .wrapper: .content
        img.titelbild(:src="require(`@/assets/img/titelbild.jpg`)")

</template>

<script>
export default {

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@media (max-width: 1200px) {
  .img-home{
    display: none;
  }
  .btn{
    margin-top: 35px;
  }
}
</style>
